import router, { baseRoutes } from './index'
import { isLogin } from '@/utils/auth'
import usePermission from '@/hooks/usePermission.js'
import { useCacheStore } from '@/stores'

router.beforeEach(async (to, from, next) => {
  const hasLogin = isLogin()
  const { getFirstPermissionPage, isAccessible } = usePermission()

  const cacheStore = useCacheStore()
  cacheStore.handleRouteChange(to, from)

  // 基础路由判断
  const whiteNames = findRouteByName(baseRoutes, to.name)
  if (whiteNames) {
    return next()
  }

  // 是否登录判断
  if (hasLogin) {
    // 已经登录的跳转到首页
    if (to.name !== 'Login') {
      if (isAccessible(to)) {
        next()
      } else {
        next('/noPermission')
      }
    } else {
      next(getFirstPermissionPage())
    }
  } else {
    // 跳转到登录页
    next(`/login?redirect=${to.fullPath}`)
  }
})

// 递归查找多层结构路由name
function findRouteByName(routes, targetName) {
  // 检查routes是否为数组
  if (!Array.isArray(routes)) {
    return false
  }

  // 遍历路由数组
  for (let route of routes) {
    // 如果当前路由的name匹配目标name，返回true
    if (route.name === targetName) {
      return true
    }

    // 如果当前路由有children，递归查找children
    if (route.children && Array.isArray(route.children)) {
      const foundInChildren = findRouteByName(route.children, targetName)
      if (foundInChildren) {
        return true
      }
    }
  }

  return false
}

router.afterEach((to, from, failure) => {})

router.onError(() => {})
